<template>
  <div class="text-right" 
  :class="{
    'goTop':showBlock,
    'iosBox':client == 'iOS',
    'androidBox':client == 'Android'
  }"
  ref="withdrawalDetails" >
      <div class="details-hound-spacer" aria-hidden="true"></div>
      <div class="details-hound-fixed">
        <div class="hound">
          <img
            class="returns"
            @click="returnBtn"
            src="../../assets/h5/back2.png"
            alt=""
          />
          <p>{{ $t("withdrawalLogin.title2") }}</p>
        </div>
      </div>
      <div class="head">
        <div class="title">{{ detailsObj.withdrawAmount }}</div>
        <div class="money">{{ detailsNewObj.cc }} {{ detailsNewObj.num }}</div>
        <div class="box">
          <img
            class="head-img"
            src="../../assets/h5/icon$.png"
            alt=""
          />
          <div class="head-txt">{{ detailsNewObj.usd }}</div>
        </div>
      </div>
      <!-- 法语相关 -->
      <!-- <template v-if="aboutFr == 0">
        <Fr_bel/>
      </template> -->
      <!-- 印尼相关 -->
      <template v-if="isIndonesia">
        <Indonesia @changeChangeMate="changeChangeMate"/>
      </template>
      <template v-else>
        <template v-if="!isGpay">
          <div class="body" 
            >
            <div class="body-txt" v-if="!isTr">{{ detailsObj.pntip }}</div>
            <div class="body-txt" v-if="isTr">{{ detailsObj.bankTips }}</div>
            <div class="body-box">
              <img v-if="isTr" class="body-img" :src="detailsObj.bankLogo" alt="" />
              <img v-if="!isTr" class="body-img" :src="detailsObj.pnlogo" alt="" />
              <!-- 获取账号 -->
              <button v-if="!isTr && itemId == 8" @click="go(detailsObj.pnurl)" class="body-btn">
                {{ $t("withdrawalLogin.getAccount") }}
              </button>
            </div>
          </div>
          <div class="pay" 
            v-if="!isTr">
            <span class="payid" v-if="itemId != 5">{{ detailsObj.pnidMessage }}</span>
            <span class="payid" v-else>{{ detailsObj.pnidMessage }}</span>
            <!-- papara -->
            <template v-if="itemId == 8">
              <input
              class="pay-ipt"
              v-model="num"
              type="text"
              oninput="value=value.replace(/[^\d]/g,'')"
              maxlength="10"
              @focus="showBlockBottom"
              @blur="hideBlockBottom"
            />
            </template>
            <!-- Vodafone Cash -->
            <template v-else-if="itemId == 5">
             <input class="pay-ipt"
             v-model="num"
             type="text"
              @focus="showBlockBottom"
              @blur="hideBlockBottom();validateInputVodafoneCasht()"/>
            </template>
            <!-- payoneer -->
            <template v-else-if="itemId == 6">
             <input class="pay-ipt"
             v-model="num"
             type="text"
              @focus="showBlockBottom"
              @blur="hideBlockBottom();validateInputPayoneerAccount()"/>
            </template>
            <!-- USTD Dreamo-->
            <template v-else-if="itemId == 13 || itemId == 17">
             <input class="pay-ipt"
             v-model="num"
             type="text"
              @focus="showBlockBottom"
              @blur="hideBlockBottom();validateInputTrc20()"/>
            </template>
            <!-- paypal -->
             <template v-else-if="itemId == 12">
              <input class="pay-ipt" v-model="num" @focus="showBlockBottom"
              @blur="hideBlockBottom();validateInputPaypalAccount()"/>
             </template>
            <template v-else>
                <input class="pay-ipt" v-model="num" type="number" @focus="showBlockBottom"
              @blur="hideBlockBottom"/>
            </template>
            <span v-show="numsta" class="errtxt">{{
              $t("withdrawalLogin.incorrectAccount")
            }}</span>
          </div>
      <!-- payeeName -->
          <div class="pay" 
            v-if="isTr">
            <span class="payid">{{ detailsObj.pmnameMessage }}</span>
            <input class="pay-ipt" v-model="payeeName" @focus="showBlockBottom"
              @blur="hideBlockBottom"/>
            <span v-show="payeeNameTips" class="errtxt">{{ detailsObj.pmnameTip }}</span>
          </div>
          <!-- payeeAccount -->
          <div class="pay" 
            v-if="isTr">
            <span class="payid">{{ detailsObj.pmaccountMessage }}</span>
            <input class="pay-ipt" v-model="payeeAccount" @input="validateInput()" @focus="showBlockBottom"
              @blur="hideBlockBottom"/>
            <span v-show="payeeAccountTips" class="errtxt">{{ detailsObj.pmaccountTip }}</span>
          </div>
          <div class="pay">
            <span class="payid">{{ detailsObj.whatsAppMessage }}</span>
            <input class="pay-ipt" v-model="id" type="number" 
          :placeholder="detailsObj.whatsAppTip2" 
            @focus="showBlockBottom"
              @blur="hideBlockBottom"/>
            <span v-show="idsta" class="errtxt">{{
              $t("withdrawalLogin.Whatsapp")
            }}</span>
            <div class="pay-txt">{{ detailsObj.pnotherTip }}</div>
          </div>
          <button
            v-if="!isTr"
            :disabled="!num ? true : false"
            class="anbtn"
            :class="{ bg: !num ? true : false }"
            @click="submit"
          >
            {{ $t("withdrawalLogin.Confirm") }}
          </button>
          <button
            v-if="isTr"
            :disabled="(!payeeName || !payeeAccount)? true : false"
            class="anbtn"
            :class="{ bg: (!payeeName || !payeeAccount)? true : false }"
            @click="submitTr"
          >
            {{ $t("withdrawalLogin.Confirm") }}
          </button>
          <!-- <div v-if="changeMate" class="meta">
            <div class="meta-box">
              <van-loading
                v-if="display"
                type="spinner"
                color="#cccccc"
                size="120px"
              />
              <van-icon v-else name="success" size="120px" color="#4D70FF" />
            </div>
            <div
              v-if="!display"
              v-html="detailsObj.pnreturnMsg"
              class="meta-txt"
            ></div>

            <button @click="returntwo" class="onBtn">
              {{ $t("roomParty.back") }}
            </button>
          </div> -->
          <div v-if="showBlock" style="height: 5rem"></div>
        
        </template>
        <!-- Gpay支付 -->
        <template v-else>
          <div class="gPayBox">
            <div class="gPayLog">
              <img :src="detailsObj.pnlogo" alt="">
              <p>{{ detailsObj.pntip }}</p>
            </div>
            <div class="gPayInput">
              <div class="gPayLabel">
                <p>{{ detailsObj.userFullName }}</p>
                <div>
                  <input type="text" :placeholder="detailsObj.userFullNameInfo" v-model="gPayInfo.accountName"  @focus="showBlockBottom"
                @blur="hideBlockBottom"  maxlength="30">
                </div>
              </div>
              <div class="gPayLabel">
                <p>{{ detailsObj.bank }}</p>
                <div class="selectInput activeSelect" @click="changeMenuFlag(1)">{{ gPayBankName }} <i></i></div>
                <div class="downMenu" v-if="menuFlag == 1" @click="changeMenuFlag(0)">
                  <div class="searchBank" @click.stop>
                    <input type="text" v-model="banName" :placeholder="detailsObj.bankName"  @click.stop/>
                  </div>
                  <p v-for="item in filteredBankList" :key="item.code" @click="changeBank(item)">{{ item.name }}</p>
                  <p style="text-align: center" v-if="filteredBankList && filteredBankList.length == 0">{{  $t('not_exist') }}</p>
                </div>
              </div>
              <div class="gPayLabel">
                <p>{{ detailsObj.iban }}</p>
                <div>
                  <input type="text" 
                @focus="showBlockBottom"
                @blur="hideBlockBottom" :placeholder="detailsObj.ibanInfo" v-model.trim="gPayInfo.iban"  maxlength="40">
                </div>
              </div>
              <!-- <div class="gPayLabel">
                <p>Account Type</p>
                <div class="selectInput" @click="changeMenuFlag(2)">Card <i></i></div>
                <div class="downMenu" v-if="menuFlag == 2" @click="changeMenuFlag(0)">
                  <p @click="changeAccountType(0,'CARD')">Card</p>
                  <p @click="changeAccountType(1,'ACCOUNT')">Bank Account</p>
                </div>
              </div> -->
              <!-- <div class="gPayLabel">
                <p>Account Number</p>
                <div>
                  <input type="text" placeholder="全名" v-model="gPayInfo.accountNumber" oninput="value=value.replace(/[^\d]/g,'')">
                </div>
              </div> -->
              <div class="gPayLabel">
                <p>{{ detailsObj.whatsAppMessage }}</p>
                <div>
                  <input type="text" v-model="id" @focus="showBlockBottom"
                @blur="hideBlockBottom" oninput="value=value.replace(/[^\d]/g,'')">
                </div>
              </div>
            </div>
            <p class="gPayTips">{{ detailsObj.whatsAppTip }}</p>
            <div class="gPayBtn" @click="gPaySubmit">{{ $t('withdrawalLogin.Confirm') }}</div>
            <div  v-show="showBlock" style="height: 40vh;"></div>
          </div>
          <van-overlay :show="loadingShow">
            <van-loading size="50px" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);"/>
          </van-overlay>
          <!-- <div v-if="changeMate" class="meta">
            <div class="meta-box">
              <van-loading
                v-if="display"
                type="spinner"
                color="#cccccc"
                size="120px"
              />
              <van-icon v-else name="success" size="120px" color="#4D70FF" />
            </div>
            <div
              v-if="!display"
              v-html="detailsObj.pnreturnMsg"
              class="meta-txt"
            ></div>

            <button @click="returntwo" class="onBtn">
              {{ $t("roomParty.back") }}
            </button>
          </div> -->
        </template>
      </template>
      <SuccessDialog v-if="changeMate" :detailsNewObj="detailsNewObj" :pnreturnMsg="detailsObj.pnreturnMsg" :withdrawAmount="detailsObj.withdrawAmount"/>
  </div>
</template>

<script>
import axios from "axios";
import { Toast,Overlay, Loading, Icon } from "vant";
import Fr_bel from "./fr_bel_ma_dz.vue";
import Indonesia from "./indonesia.vue";
import SuccessDialog from "./successDialog.vue";
export default {
  name: "App",
  components:{
    Fr_bel,
     VanOverlay: Overlay,
    VanLoading: Loading,
    VanIcon: Icon,
    Indonesia,
    SuccessDialog
  },
  // 提现详情表单数据、校验状态与 GPay/印尼渠道相关配置
  data() {
    return {
      client: 'PC',
      showBlock: false,
      userInfo: [],
      detailsObj: {},
      detailsNewObj: {},
      num: "",
      id: "",
      statusCha: false,
      idsta: false,
      numsta: false,
      language: "",
      uid: "",
      token: "",
      changeMate: false,
      display: true,
      deviceId: '',
      payeeAccount:'',
      payeeName:'',
      payeeNameTips: false,
      payeeAccountTips:false,
      isTr: true,
      // Gpay
      isGpay: false,
      menuFlag: 0,
      loadingShow: false,
      gPayInfo:{
        branchNumber:'111111',
        bankId:'',
        iban: '',
        accountNumber:'111111',
        accountName:'',
        // type: 'CARD',
        type: 'ACCOUNT',
      },
      gPayBankName:'',
      sabankList:[],
      gPayTips:'',
      banName:'',
      // payoneer7 USDT13 paypal12
      itemId:0,
      focusScrollTimer: null,
      /** 键盘曾处于缩小 visualViewport 状态，用于区分「未弹键盘」与「收起键盘但未 blur」（2026-05-08） */
      keyboardWasOpen: false,
      keyboardCloseDebounceTimer: null,
    };
  },
  computed:{
    // 是否是印尼支付  15 MP_BANK_TRANSFER 、16 MP_E_WALLET 、18 PM_OVO 、 19 PM_DANA、20 PM_GOPAY 、 21 PM_LINKAJA 、 22 PM_SHOPEEPAY
    isIndonesia(){
      return this.itemId == 15 || this.itemId == 16 || this.itemId == 18 || this.itemId == 19 || this.itemId == 20 || this.itemId == 21 || this.itemId == 22 ;
    },
    gPayInfoAll(){
      if(!this.gPayInfo.accountName){
        this.gPayTips = this.detailsObj.userFullNameInfo;
        return false;
      }else if(!this.gPayInfo.bankId){
        this.gPayTips = this.detailsObj.select + this.detailsObj.bank;
        return false;
      }else if(!this.gPayInfo.iban){
        this.gPayTips = this.detailsObj.ibanInfo;
        return false;
      }else if(!this.id){
        this.gPayTips = this.detailsObj.whatsAppTip;
        return false;
      }else{
        return true;
      }
    },
    // 计算属性用于实时过滤数组
    filteredBankList() {
      const query = this.banName.toLowerCase();
      if (!query) {
        return this.sabankList; // 如果没有查询，则返回所有项
      }
      return this.sabankList.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    }
  },
  // 初始化：读取路由渠道/详情参数、本地鉴权与缓存，设置 GPay/土耳其等分支
  created() {
    let newobj = JSON.parse(this.$route.query.newobj);
    this.detailsNewObj = newobj;
    console.log(this.detailsNewObj)
    let obj = JSON.parse(this.$route.query.obj);
    this.detailsObj = obj;
    this.itemId = this.$route.query.id;
      // 等于4说明是土耳其
      if(this.itemId == 4 ){
        this.isTr = true;
      }else{
        this.isTr = false;
      }
        var ids = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }

    if(!this.isTr && this.detailsObj.pnreturnMsg){
      this.detailsObj.pnreturnMsg = this.detailsObj.pnreturnMsg.replace(
        "\n",
        "<br>"
      );
    }
    let data = JSON.parse(localStorage.getItem("data"));
    this.language = data.lang || navigator.language;
    this.uid = data.uid || data.userId;
    this.deviceId = data.deviceId || ids
    this.token = data.token;
    // itemId对应体现渠道的id，账号字段按 uid 隔离
    this.num = localStorage.getItem("num" + this.itemId + "_" + this.uid);
    this.id = localStorage.getItem("id" + "_" + this.uid);
    if(data.uid){
      this.changeTime()
    }
      // GPay支付
    if(JSON.parse(this.$route.query.id)  == 11){
      this.isGpay = true;
      this.gPayBankName = this.detailsObj.select;
      this.getBanList()
    }
     this.judgeClient();

  },
  // 挂载后初始化 i18n 语言并设置页面标题
  mounted() {
    let langs = this.language.substring(0, 2);
    if (langs == "zh") {
      if (this.language == "zh-TW" || this.language == "zh-HK") {
        this.$i18n.locale = "tc";
      } else {
        this.$i18n.locale = "zh";
      }
    } else if (langs == "en") {
      this.$i18n.locale = "en";
    } else if (langs == "ar") {
      this.$i18n.locale = "ar";
    } else if (langs == "tr") {
      this.$i18n.locale = "tr";
    } else if (langs == "es") {
      this.$i18n.locale = "es";
    } else if (langs == "pt") {
      this.$i18n.locale = "pt";
    } else if (langs == "fr") {
      this.$i18n.locale = "fr"
    } else if (langs == "id") {
      this.$i18n.locale = "id"
    } else if (langs == "ms") {
      this.$i18n.locale = "ms"
    } else {
      this.$i18n.locale = "en";
    }
    document.title = this.$t("withdrawalLogin.title2");
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);

  },
  // 销毁前清理滚动/键盘相关定时器并移除监听
  beforeDestroy() {
    if (this.focusScrollTimer) {
      clearTimeout(this.focusScrollTimer);
      this.focusScrollTimer = null;
    }
    if (this.keyboardCloseDebounceTimer) {
      clearTimeout(this.keyboardCloseDebounceTimer);
      this.keyboardCloseDebounceTimer = null;
    }
    this.teardownViewportScrollListener();
  },
  methods: {
    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
    // 修改选择银行
    changeBank(item){
      this.gPayBankName = item.name;
      this.gPayInfo.bankId = item.code;
    },
    // 请求银行列表
    getBanList(){
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${JSON.parse(this.$route.query.id)}`,{
              headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.sabankList = response.data.data.sabankList;
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },  
    // 切换账户类型（GPay）
    changeAccountType(type, newAccount){
      this.gPayInfo.type = newAccount;
    },  
    // 确定按钮事件
    gPaySubmit(){
      if(this.gPayInfoAll){
        this.submitBtn();
      }else{
        Toast(this.gPayTips);
      }
    },  
    // 展开银行列表
    changeMenuFlag(type){
      this.menuFlag = type;
    }, 
    // 校验Payoneer Account
    validateInputPayoneerAccount(){
      const value = this.num.trim();
      if (!value) {
        this.numsta = true;
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(value)) {
        this.numsta = false;
      }else {
        this.numsta = true;
      }
    },
    // 校验Vodafone Cash
    validateInputVodafoneCasht(){
     // 去掉非数字字符
      const num = this.num.trim();
      // 校验长度：11 位数字（埃及本地号码）
      if (num.length !== 11) {
        this.numsta = true;
        return;
      }
      // 校验前缀：以 "010" 开头（Vodafone Egypt 的常见前缀）
      if (!num.startsWith('01')) {
        this.numsta = true;
        return;
      }
      this.numsta = false;
    },
    // 校验PayPal Account
    validateInputPaypalAccount(){
      const value = this.num.trim();
      if (!value) {
        this.numsta = true;
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const phoneRegex = /^\d{1,30}$/;
      if (emailRegex.test(value)) {
        this.numsta = false;
      } else if (phoneRegex.test(value)) {
        this.numsta = false;
      } else {
        this.numsta = true;
      }
    },  
    // 校验trc20和bep20
    validateInputTrc20(){
      const value = this.num.trim();
      if (!value) {
        this.numsta = true;
        return;
      }
      const trcRegex = /^T[a-zA-Z1-9]{33}$/;
      const bepRegex = /^0x[a-fA-F0-9]{40}$/;
      if (trcRegex.test(value) || bepRegex.test(value)) {
        this.numsta = false;
      }else {
        this.numsta = true;
      }
    },
    // 校验土耳其输入银行卡号可以有英文
    validateInput(){
      this.payeeAccount =  this.payeeAccount.replace(/[^\w\.\/]/ig,'');
    },
    // 仅在被键盘遮挡时做最小滚动，保持输入框在 visualViewport 内（2026-05-08）
    // 确保当前聚焦的输入框保持在可视区域内（滚动页面到合适位置）
    ensureActiveInputVisible() {
      const el = document.activeElement;
      if (
        !el ||
        (el.tagName !== "INPUT" && el.tagName !== "TEXTAREA")
      ) {
        return;
      }
      const vv = window.visualViewport;
      let visibleTop = 0;
      let visibleBottom = window.innerHeight;
      if (vv) {
        visibleTop = vv.offsetTop;
        visibleBottom = vv.offsetTop + vv.height;
      }
      const padding = 12;
      const rect = el.getBoundingClientRect();
      let delta = 0;
      if (rect.bottom > visibleBottom - padding) {
        delta = rect.bottom - (visibleBottom - padding);
      } else if (rect.top < visibleTop + padding) {
        delta = rect.top - (visibleTop + padding);
      }
      if (!delta) return;

      const scrollRoot = this.$refs.withdrawalDetails;
      if (
        scrollRoot &&
        scrollRoot.scrollHeight > scrollRoot.clientHeight
      ) {
        const maxScroll = scrollRoot.scrollHeight - scrollRoot.clientHeight;
        scrollRoot.scrollTop = Math.min(
          maxScroll,
          Math.max(0, scrollRoot.scrollTop + delta)
        );
      } else {
        window.scrollBy({ top: delta, left: 0, behavior: "auto" });
      }
    },
    // 监听 visualViewport 的 resize/scroll，用于键盘遮挡时保持输入可见
    setupViewportScrollListener() {
      this.teardownViewportScrollListener();
      const vv = window.visualViewport;
      if (!vv) return;
      this._vvResizeHandler = () => {
        this.ensureActiveInputVisible();
        this.syncShowBlockWithKeyboard();
      };
      vv.addEventListener("resize", this._vvResizeHandler);
      vv.addEventListener("scroll", this._vvResizeHandler);
    },
    // 移除 visualViewport 监听并清理键盘关闭防抖定时器
    teardownViewportScrollListener() {
      if (this.keyboardCloseDebounceTimer) {
        clearTimeout(this.keyboardCloseDebounceTimer);
        this.keyboardCloseDebounceTimer = null;
      }
      const vv = window.visualViewport;
      if (vv && this._vvResizeHandler) {
        vv.removeEventListener("resize", this._vvResizeHandler);
        vv.removeEventListener("scroll", this._vvResizeHandler);
        this._vvResizeHandler = null;
      }
    },
    /**
     * 真机点「收起键盘」时往往不触发 input blur，仅靠 blur 无法去掉底部站位。
     * 在 visualViewport 恢复接近整屏高度时收起站位（需先经历过键盘缩小，避免误伤）。
     */
    syncShowBlockWithKeyboard() {
      if (!this.showBlock) return;
      const vv = window.visualViewport;
      if (!vv || !window.innerHeight) return;
      const ratio = vv.height / window.innerHeight;
      if (ratio < 0.82) {
        this.keyboardWasOpen = true;
      }
      if (!this.keyboardWasOpen || ratio < 0.88) return;
      if (this.keyboardCloseDebounceTimer) {
        clearTimeout(this.keyboardCloseDebounceTimer);
      }
      this.keyboardCloseDebounceTimer = setTimeout(() => {
        this.keyboardCloseDebounceTimer = null;
        const vv2 = window.visualViewport;
        if (!this.showBlock || !vv2) return;
        const r = vv2.height / window.innerHeight;
        if (this.keyboardWasOpen && r >= 0.88) {
          this.keyboardWasOpen = false;
          this.hideBlockBottom();
        }
      }, 120);
    },
    // 底部增加方块站位
    showBlockBottom() {
      if (this.focusScrollTimer) {
        clearTimeout(this.focusScrollTimer);
        this.focusScrollTimer = null;
      }
      this.keyboardWasOpen = false;
      this.teardownViewportScrollListener();
      this.showBlock = true;
      this.$nextTick(() => {
        this.focusScrollTimer = setTimeout(() => {
          this.focusScrollTimer = null;
          this.ensureActiveInputVisible();
          this.setupViewportScrollListener();
        }, 250);
      });
    },
    // 底部方块隐藏
    hideBlockBottom() {
      if (this.focusScrollTimer) {
        clearTimeout(this.focusScrollTimer);
        this.focusScrollTimer = null;
      }
      this.keyboardWasOpen = false;
      if (this.keyboardCloseDebounceTimer) {
        clearTimeout(this.keyboardCloseDebounceTimer);
        this.keyboardCloseDebounceTimer = null;
      }
      this.teardownViewportScrollListener();
      this.showBlock = false;
    },
    // 返回按钮：无上一页时关闭 webview，否则路由返回
    returnBtn() {
      // this.$router.push({
      //   path:'/withdrawal',
      //   query:{
      //     type:1
      //   }
      // });
      if (window.history.length <= 1) {
          // 没有上一页，关闭webview
          this.$completes.complete("getPreviousPage");
      } else {
          this.$router.go(-1);
      }
    },

    // 跳转到外部链接
    go(url) {
      window.location.href = url;
    },
    // 提交标准渠道：先校验 WhatsApp，再校验 Papara 长度，通过后提交
    submit() {
      if (this.id == "") {
        this.idsta = true;
      } else {
        this.idsta = false;
      }
      // Papara 渠道：账号需 ≥10 位
      if (this.detailsObj.pnurl == "https://www.papara.com/") {
        if (this.num && this.num.length < 10) {
          this.numsta = true;
        } else {
          this.numsta = false;
        }
      }
      // 全部校验通过才调用提现接口
      if (!this.idsta && !this.numsta) {
        this.submitBtn();
      }
    },
    // 土耳其提现：校验收款账号/姓名（≥5位）/WhatsApp 后提交
    submitTr(){
      if(this.payeeAccount == '' ){
        this.payeeAccountTips = true;
      }else{
        this.payeeAccountTips = false;
      }
      if(this.payeeName == '' || this.payeeName.length < 5){
        this.payeeNameTips = true;
      }else{
        this.payeeNameTips = false;
      }
      if (!this.id) {
        this.idsta = true;
      } else {
        this.idsta = false;
      }
      // 全部校验通过才提交
      if (!this.idsta && !this.payeeAccountTips && !this.payeeNameTips) {
        this.submitBtn();
      }
    },
    // 子组件（印尼）绑定成功后标记成功
    changeChangeMate(){
      this.changeMate = true;
    },
    // 组装参数并调用提现接口 applyForWeb
    submitBtn() {
      if(this.loadingShow) return;
      this.loadingShow = true;
      let that = this;
      // 保存绑定时即缓存账号与 WhatsApp 供下次回填（按 uid 隔离），不等待提现成功
      localStorage.setItem("num" + this.itemId + "_" + that.uid, that.num);
      localStorage.setItem("id" + "_" + that.uid, that.id);
      let paramsObj = {};
      // gPay单独处理：iban 去空白后随账户信息一起提交
      if(JSON.parse(this.$route.query.id)  == 11){
        paramsObj = {whatsApp: that.id }
        this.gPayInfo.iban = this.gPayInfo.iban.replace(/\s+/g, '')
        paramsObj = Object.assign(paramsObj,this.gPayInfo)
      }else{
        // 土耳其单独处理：收款账号 + 姓名 + WhatsApp
        if(this.isTr){
          paramsObj = { payeeAccount: that.payeeAccount, payeeName: that.payeeName, whatsApp: that.id }
        }else{
          // Vodafone Cash单独处理  17dreamo渠道：账号字段用 account
          if(that.itemId == 5 || that.itemId == 17){
            paramsObj = { account: that.num, whatsApp: that.id }
          }else{
            paramsObj = { payeeAccount: that.num, whatsApp: that.id }
          }
          
        }
      }
      // 组装订单对象：自定义档位 mode=2 带 pocketCoin，固定档位 mode=1 用渠道 id
      let dataObj = {}
      if(that.detailsNewObj.id == 0){
        dataObj.cid = that.detailsNewObj.channel + '';
        dataObj.mode = 2;
        dataObj.pocketCoin = that.detailsNewObj.usd
      }else{
        dataObj.cid = that.detailsNewObj.id + "" ;
        dataObj.mode = 1;
      }
      axios({
        url: that.$serviceIp + `api/trade/card/tx/applyForWeb`,
        method: "post",
          headers: {
            'deviceId': that.deviceId,
            'lang': that.lang,
          },
        data: {
          ...dataObj, 
          params: paramsObj,
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
          this.changeMate = true;
          // 3 秒后切换为成功图标
          setTimeout(this.nshbhxbh, 3000);
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
        this.loadingShow = false
      });
    },
    // 延迟回调：隐藏成功展示层
    nshbhxbh() {
      this.display = false;
    },
    // 返回提现主页
    returntwo() {
      this.$router.push("/withdrawal");
    },

    // 登录过期检测：time 早于当前时间则清理缓存并跳转登录页
    changeTime() {
      let item = JSON.parse(localStorage.getItem("time"));
      if (item < Date.now()) {
        localStorage.removeItem("data");
        localStorage.removeItem("time");
        localStorage.removeItem("num");
        localStorage.removeItem("id");
        this.$router.push("/withdrawalLogin");
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.iosBox{
  /* iOS安全区域适配 */
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top); /* iOS 11.0-11.2 兼容 */
}
/* 仅顶栏 hound 固定；占位 = hound 高度 + margin-bottom（2026-05-08） */
.details-hound-spacer {
  width: 100%;
  height: 142px;
  flex-shrink: 0;
  pointer-events: none;
}
.details-hound-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  box-sizing: border-box;
  /* padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top); */
  background-color: #fff;
}
html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}
html[lang="ar"] .gPayBox{
  direction: rtl;
} 
html[lang="ar"] .gPayLabel input{
  padding-right: 28px;
}
html[lang="ar"] .gPayLabel .selectInput{
  padding-right: 28px;
}
html[lang="ar"] .selectInput i{
  left: 28px;
  right: auto;

  transform: scale(-1);
}
html[lang="ar"] .searchBank input{
  padding-right: 70px;
}
html[lang="ar"] .searchBank::before{
  left: auto;
  right: 24px;
}
.gPayLog{
  width: 598px;
  height: 174px;
  border-radius: 24px;
  margin: 24px auto 0;
  background: #EEE7F3;
  padding-top: 24px;
  box-sizing: border-box;
}
.gPayLog img{
  display: block;
  width: 130px;
  height: 80px;
  margin: 0 auto 16px;
  object-fit: contain;
}
.gPayLog p{
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
  color: #000000;
}
.gPayBox{
  width: 598px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.gPayLabel{
  margin-top: 48px;
  position: relative;
}
.gPayLabel>p{
  font-size: 26px;
  line-height: 30px;
  font-weight: 500;
  margin-bottom: 16px;
}
.gPayLabel p::after{
  display: inline-block;
  content: '';
  width: 10px;
  height: 11px;
  background: url('../../assets/h5/*.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-left: 3px;
}
.gPayLabel>div:not(.downMenu){
  height: 94px;
}
.gPayLabel input{
  width: 100%;
  border: 1px solid #262427;
  border-radius: 28px;
  height: 92px;
  padding-left: 28px;
  font-size: 26px;
  line-height: 92px;
  color: #000000;
  box-sizing: border-box;
  vertical-align: top;
  background: transparent;
}
.gPayLabel input::placeholder { /* 标准语法 */
  color: #AFA9B4;
  opacity: 1; /* 确保 Firefox 和其他浏览器一致 */
}
.gPayLabel .selectInput{
  width: 100%;
  border: 1px solid #262427;
  border-radius: 28px;
  height: 92px;
  padding-left: 28px;
  font-size: 26px;
  line-height: 92px;
  box-sizing: border-box;
  color: #AFA9B4;
  position: relative;
}
.selectInput i{
  position: absolute;
  width: 32px;
  height: 32px;
  background: url('../../assets/h5/right.png') no-repeat;
  background-size: 100% 100%;
  top: 30px;
  right: 28px;
}
.activeSelect{
  color: #000000!important;
}
.gPayTips{
  font-size: 26px;
  line-height: 30px;
  color: #89848D;
  margin-top: 24px;
  margin-bottom: 84px;
}
.gPayBtn{
  width: 422px;
  height: 92px;
  border-radius: 46px;
  text-align: center;
  font-size: 32px;
  line-height: 92px;
  color: #AFA9B4;
  background: #DFD9E3;
  color: #ffffff;
  background: #4D70FF;
  margin: 0 auto 14px;
}
.downMenu{
  width: 100%;
  max-height: 632px!important;
  min-height: 200px!important;
  background: #fff;
  border-radius: 20px;
  padding: 28px 28px 0;
  box-sizing: border-box;
  position: absolute;
  z-index: 1;
  overflow: auto;
  top: 150px;
  left: 0;
  box-shadow: 
    0px 0px 10px 2px rgba(0, 0, 0, 0.08); /* 外部扩散的四周阴影 */
}
.downMenut {
  scrollbar-width: none; /* 针对Firefox */
  -ms-overflow-style: none; /* 针对Internet Explorer 和 Edge */
}

.downMenu::-webkit-scrollbar {
  display: none; /* 针对Webkit浏览器（如Chrome和Safari） */
}
.downMenu p{
  font-size: 26px;
  line-height: 88px;
  height: 88px;
  border-bottom: 1px solid #eee;
  font-weight: 500;
  color: #262427;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.downMenu p::after{
  display: none;
}
.searchBank{
  height: 76px;
  position: relative;
}
.searchBank input{
  width: 528px;
  height: 76px;
  border: none;
  border-radius: 24px;
  background: #F5F6F8;
  padding-left: 70px;
  box-sizing: border-box;
  vertical-align: top;
}
.searchBank:before{
  position: absolute;
  top: 22px;
  left: 24px;
  content:'';
  width: 32px;
  height: 32px;
  background: url('../../assets/h5/searchIcon.png') no-repeat;
  background-size: 100% 100%;
}

.hound {
  width: 100%;
  height: 130px;
  display: flex;
  align-items: center;
  padding-top: 30px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  position:relative;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.returns {
  width: 28px;
  height: 28px;
      position:absolute;
}

.hound p {
  flex: 1;
  font-size: 0.31rem;
  text-align: center;
  color: #000000;
}

.text-right {
  /* display: flex;
  flex-direction: column;
  align-items: center; */
  display: block;
  text-align: center;
  height: 14rem;
  text-align: left;
  font-family: 'Mada';
}
.head {
  /* width: 5.98rem;
  height: 2.1rem; */
  /* background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%); */
  /* border-radius: 12px; */
  width: 600px;
  height: 274px;
  background: url('../../assets/h5/detailHeadBg.png') no-repeat;
  background-size: 100% 100%;
  /* margin-top: 0.8rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin:0 auto 0;
  padding-top: 54px;
  box-sizing: border-box;
}

.title {
  font-weight: 600;
  font-size: 28px;
  color: #fff;
}
.money {
  font-weight: 700;
  font-size: 48px;
  color: #fff;
  margin: 18px 0;
}
.box {
  /* height: 0.4rem; */
  display: flex;
  align-items: center;
}
.head-img {
  width: 22px;
  height: 23px;
}
.head-txt {
  font-weight: 400;
  font-size: 28px;
  color: rgba(255, 255, 255 , 0.8);
  margin-left: 8px;
}

.body {
  width: 5.9rem;
  margin: 0 auto;
}
.body-txt {
  height: 0.3rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.3rem;
  color: #acadbc;
  margin-top: 0.4rem;
  margin-bottom:-0.2rem;
}
.body-box {
  /* height: 0.72rem; */
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body-img {
  /* width: 1.79rem; */
  height: 0.5rem;
}
.body-btn {
  min-width: 2rem;
  height: 0.68rem;
  font-style: normal;
  font-weight: 500;
  font-size: 0.27rem;
  color: #ffffff;
  background: #4D70FF;
  border-radius: 27px;
  border: none;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay {
  width: 5.9rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
  margin: 0.4rem auto;
}

.payid {
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: #000000;
}
.payid::after{
  content: '*';
  color: #FF4365;
}
.pay-ipt {
  width: 5.9rem;
  height: 0.82rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  color: #000000;
  background: #f3f3f5;
  border-radius: 12px;
  border: none;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
  border: 1px solid #CECAD1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.pay-txt {
  height: 0.58rem;
  color: #acadbc;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  margin-top: 0.2rem;
}
.anbtn {
  display: block;
  width: 4.1rem;
  height: 0.82rem;
  background: #4D70FF;
  border-radius: 24px;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  text-align: center;
  color: #ffffff;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin: 0 auto;
}
.errtxt {
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #FF4365;
  margin-top: 0.1rem;
}
.bg {
  color: #acadbc;
  background-color: #f3f3f5;
}

.meta {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.meta-box {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meta-txt {
  width: 85%;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 20px;
  color: #000000;
  text-align: center;
}

.onBtn {
  width: 2.5rem;
  height: 0.82rem;
  font-size: 0.27rem;
  color: #ffffff;
  border-radius: 12px;
  text-align: center;
  line-height: 0.82rem;
  background-color: #4D70FF;
  border: none;
  box-sizing: border-box;
  margin-top: 0.6rem;
}
.goTop{
  height: 100vh;
  overflow-y: auto;
  /* transform: translateY(-5rem); */
}
.trBankCardBox{
  width: 5.98rem;
  height: 2.1rem;
  background: #f3f3f5;
  border-radius: 0.12rem;
  margin: 0.2rem auto 0;
  padding: 0.2rem;
  box-sizing: border-box;
}
.trBankCardBox p{
  color: #acadbc;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  text-align: left;
  color: #000000;
  margin-top: 0.2rem;
}
.bankCardLogoBox{
  margin-top: 0.5rem;
}
.bankCardLogo{
  display: block;
  width: 1rem;
  height: 0.6rem;
}
</style>
